/**
 * Rich text / Quill bodies may be incomplete HTML (unclosed tags) or have a BOM;
 * avoid detectors that require a closing `>` before treating content as HTML.
 */

export function normalizeWidgetHtmlBody(raw: string): string {
  return raw.replace(/^\uFEFF/, '').trimStart();
}

/** True when the string appears to contain an HTML tag open (not e.g. "1 < 2"). */
export function bodyLooksLikeHtml(body: string): boolean {
  const s = normalizeWidgetHtmlBody(body);
  if (!s) return false;
  return /<\/?[a-z]/i.test(s);
}
